import { defineMessages } from 'react-intl';

export default defineMessages({
  optional: {
    id: 'app.components.Form.label.optional',
    defaultMessage: '(optional)',
  },
});
